import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"

function ActiveSkeleton() {
  return (
    <Fragment>
      <div className={classnames(styles.activeContainer)}>
        <div className="u-flex u-flexJustifyBetween">
          <div className={classnames(styles.skeleton, styles.textActive)}></div>
          <div
            className={classnames(styles.skeleton, styles.activeToggle)}
          ></div>
        </div>
      </div>
    </Fragment>
  )
}

export default ActiveSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/AutomaticDebitSkeleton/ActiveSkeleton.js